import { useDispatch } from "react-redux";
import { LayerBox } from "../index";
import {
  displayRegionLayerOnMap,
  doFetchAllLayers,
  openAddRegionLayerScreen,
  openEditRegionLayerScreen,
  openViewRegionLayerScreen,
  resetMap,
  updateSelectedItemToZoom,
  updateSelectedLayersItems,
} from "store/geography";
import { useSelector } from "react-redux";
import { RootState } from "store";
import { useLocation, useParams } from "react-router-dom";
import apiLibrary from "services/api";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { ICommunity } from "store/communityProfile";
import { Toasts } from "view/components/Toasts";
import { CurrentOpenToggleType, T_RegionLayersData } from "../LayersListing";
import usePermissions from "hooks/usePermissions";

interface I_RegionLayerBox {
  data: T_RegionLayersData[] | undefined;
  actionsList: {
    label: string;
  }[];
  global?: boolean;
  setEntityType?: Dispatch<SetStateAction<string | null>>;
  setPage?: Dispatch<SetStateAction<any>>;
  entityType?: null | string;
  page?: any;
  totalPages?: number;
  totalItems?: number;
  loading: boolean;
  currentOpenToggle: CurrentOpenToggleType;
  // setCurrentOpenToggle: Dispatch<SetStateAction<CurrentOpenToggleType>>;
}

const RegionLayerBox = ({
  data,
  actionsList,
  setEntityType,
  setPage,
  entityType,
  totalPages,
  page,
  totalItems,
  loading,
  currentOpenToggle,
  // setCurrentOpenToggle,
}: I_RegionLayerBox) => {
  const [isScrollEndEventTriggered, setIsScrollEndEventTriggered] =
    useState(false);
  const [layers, setLayers] = useState<T_RegionLayersData[] | undefined>();
  const [doShowDataList,setDoShowDataList] = useState(false);
  const { selectedLayersItems } = useSelector(
    (state: RootState) => state.geography
  );
  const { geographies, communities } = usePermissions();
  const location = useLocation();
  const dispatch = useDispatch();
  const { communityId } = useParams();

  const state = location.state;
  const heading = `${
    !totalItems || totalItems === 0 ? "" : totalItems
  } Regions`;

  // useEffect(() => {
  //   if (data && data.length > 0 && state && state.redirectFromKPI) {
  //     const AllRegions = data.map((item: any) => {
  //       return { item, itemType: "region", status: true };
  //     });

  //     setTimeout(() => {
  //       dispatch(updateSelectedLayersItems(AllRegions));
  //     }, 2000);
  //   }
  //   return () => {
  //     dispatch(resetMap(true));
  //   };
  // }, [state, data]);

  useEffect(()=>{
      setDoShowDataList(currentOpenToggle === "region");
  },[currentOpenToggle])

  useEffect(() => {
    setLayers(data);
  }, [data]);

  useEffect(() => {
    if (isScrollEndEventTriggered) {
      if (
        setPage &&
        setEntityType &&
        totalPages &&
        page &&
        totalPages >= page.region + 1
      ) {
        setPage((prev: any) => {
          return { ...prev, region: prev.region + 1 };
        });

        if (entityType !== "region") {
          setEntityType("region");
        }
      }

      setIsScrollEndEventTriggered(false);
    }
  }, [isScrollEndEventTriggered]);

  // handlers
  const handleClickOnMenuAction = async (action: any, dataItem: any) => {
    const currentAction = action.label.toLowerCase();
    const selectedItem = selectedLayersItems?.find(
      (itm: any) => itm?.item?.id === dataItem?.id
    );

    switch (currentAction) {
      case "edit":
        dispatch(openEditRegionLayerScreen(dataItem));
        break;

      case "view information":
        dispatch(openViewRegionLayerScreen(dataItem));
        break;

      case "zoom to selection":
        dispatch(updateSelectedItemToZoom({ ...(selectedItem ?? {}) }));
        break;

      case "archive":
      case "restore":
        if (communityId) {
          const isArchive = currentAction === "archive";
        
          try {
            // Update layer status
            await apiLibrary.geography.updateLayerStatus(
              communityId,
              dataItem.id,
              isArchive
            );
            dispatch(doFetchAllLayers(true));
        
            // Update selected layers items
            const layersItems = selectedLayersItems || [];
            const itemIndex = layersItems.findIndex(
              (itm: any) => itm.item.id === dataItem.id
            );
        
            if (itemIndex !== -1) {
              layersItems[itemIndex].status = false;
              dispatch(updateSelectedLayersItems([...layersItems]));
            }
          } catch (error:any) {
            console.error("Failed to update layer status:", error);
            Toasts.error(error.response.data.message??error.message);
            // Optionally, add more error handling logic here, such as user notifications
          }
        }
        
        break;

      default:
        // Handle other cases here
        break;
    }
  };
  const handleClickOnAddButton = () => {
    // open add region layer screen
    dispatch(openAddRegionLayerScreen());
    dispatch(displayRegionLayerOnMap({}));
  };
  const handleClickOnCheckBox = async (e: any, item: any) => {
    const isChecked = e.target.checked;
    const layersItems = selectedLayersItems ?? [];
    const itemIndex = layersItems.findIndex(
      (itm: any) => itm.item.id === item.id
    );
    const alreadyExistedItem = layersItems[itemIndex];
    let upadatedItems;

    if (isChecked) {
      if (alreadyExistedItem) {
        // update item status to true
        alreadyExistedItem.status = true;

        layersItems[itemIndex] = alreadyExistedItem;
        upadatedItems = layersItems;
      } else {
        if (communityId) {
          await apiLibrary.geography
            .getSingleLayer(communityId, item.id)
            .then((data) => {
              const newItem = {
                item: data.data,
                itemType: "region",
                status: true,
              };
              upadatedItems = [...layersItems, newItem];

              setLayers((prev: any) => {
                const itemIndex = prev.findIndex(
                  (itm: any) => itm?.id === item?.id
                );
                if (itemIndex >= 0) {
                  prev[itemIndex] = newItem.item;
                }

                return prev;
              });
            })
            .catch((error) => {
              Toasts.error(error.message);
            });
        }
      }
    } else {
      // update item status to false on unchecking the checkbox
      alreadyExistedItem.status = false;

      layersItems[itemIndex] = alreadyExistedItem;
      upadatedItems = layersItems;
    }

    dispatch(updateSelectedLayersItems([...upadatedItems]));
  };
  const handleOnScrollEnd = () => {
    setIsScrollEndEventTriggered(true);
  };
  const handleClickOnTogglerBtn = () => {
    setDoShowDataList(!doShowDataList);
    // if (currentOpenToggle && currentOpenToggle !== "region") {
    //   setCurrentOpenToggle("region");
    // }
  };

  return (
    <LayerBox
      heading={heading}
      dataList={communities.canViewGeographyCommunities ? layers : null }
      actionList={actionsList}
      hideItemThumb={true}
      layerType="region"
      loading={loading}
      hideAddBtn={!geographies.canViewVectorLayers}
      doShowDataList={doShowDataList}
      handleClickOnMenuAction={handleClickOnMenuAction}
      handleClickOnAddButton={handleClickOnAddButton}
      handleClickOnCheckBox={handleClickOnCheckBox}
      handleOnScrollEnd={handleOnScrollEnd}
      handleClickOnTogglerBtn={handleClickOnTogglerBtn}
    />
  );
};

export { RegionLayerBox };
